import { useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";

const signingIn = { textAlign: "center" }
const signingInP = { fontSize: "16px", fontWeight: "bold" }

const AuthCallback = () => {

    const history = useHistory();
    const { inProgress, accounts } = useMsal();

    useEffect(() => {
        if (inProgress === InteractionStatus.None && accounts.length > 0) {
            history.replace("/");
        }
    }, [inProgress, accounts, history]);

    return (
        <div style={signingIn}>
            <p style={signingInP}>Kirjaudutaan sisään…</p>

            <button onClick={() => history.replace("/")}>Siirry etusivulle</button>

        </div>
    );
}

export default AuthCallback;